import { CHANGE_THEME_FAILED, CHANGE_THEME_SUCCESS, REQUEST_THEME_FAILED, REQUEST_THEME_SUCCESS } from '../constants';
import { QueryType } from '../actions/themeActions';
import { Theme } from '@material-ui/core';
import { appThemes } from '../../shared/themes/themes';
import { themeKind } from '../../constants/theme';

interface StateType {
  error?: string;
  loading: boolean;
  success: boolean;
  theme: Theme;
}
type ThemeActionType = { type: string; payload: QueryType; message?: string };

const init: StateType = {
  error: '',
  loading: false,
  success: false,
  theme: appThemes[0],
};

const successAction = (state: typeof init, action: ThemeActionType) => {
  const { theme } = action.payload;
  let result = appThemes[0];
  if (theme.kind === themeKind.light) result = appThemes[0];
  if (theme.kind === themeKind.dark) result = appThemes[1];
  return { ...state, error: '', loading: false, success: true, theme: result };
};

export default (state = init, action: ThemeActionType): StateType => {
  switch (action.type) {
    case REQUEST_THEME_FAILED: {
      return { ...state, error: action.message, loading: false, success: false };
    }
    case REQUEST_THEME_SUCCESS: {
      return successAction(state, action);
    }
    case CHANGE_THEME_FAILED: {
      return { ...state, error: action.message, loading: false, success: false };
    }
    case CHANGE_THEME_SUCCESS: {
      return successAction(state, action);
    }

    default: {
      return state;
    }
  }
};
